module.exports = __webpack_public_path__ + "img/how_to_brush_teeth_splash.7e9eb6e3.png";